import { getPriorityToken } from 'entities/Auth/lib/setToken'

/**
 * Browser client for the agent proxy's knowledge-base routes. Talks to the same
 * proxy that brokers Anthropic (the routes are JWT-verified there); the real
 * Intercom token never reaches the client. Lives in entities/ (reads the auth
 * token directly) to respect FSD layering — no import from features/.
 */
const PROXY_URL = process.env.REACT_APP_AGENT_PROXY_URL || `${window.location.origin}/__agent`

export interface HelpArticleSummary {
  articleId: string
  title: string
  url: string
  snippet: string
}

export interface HelpSearchResult {
  query: string
  results: HelpArticleSummary[]
}

export interface HelpArticleFull {
  articleId: string
  title: string
  url: string
  text: string
}

const postHelp = async <T>(path: string, body: Record<string, unknown>): Promise<T> => {
  const token = getPriorityToken()
  const res = await fetch(`${PROXY_URL}${path}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  })
  const data = (await res.json().catch(() => ({}))) as T & { error?: string }
  if (!res.ok) throw new Error(data?.error || `help request failed (${res.status})`)
  return data
}

export const searchHelpCenter = (query: string): Promise<HelpSearchResult> =>
  postHelp<HelpSearchResult>('/help/search', { query })

export const readHelpArticle = (articleId: string): Promise<HelpArticleFull> =>
  postHelp<HelpArticleFull>('/help/article', { article_id: articleId })
